export enum PayType {
  HOURLY = 'Hourly',
  SALARY = 'Salary',
}
